import { DeliveryServicesContext } from '@/contexts/DeliveryServicesContext.jsx';
import React, { useEffect, useState, useRef, useContext } from 'react';
import { SideSheet } from '@desquared/wave-components-library';
import { SideSheetStore } from '@/store/sideSheet';
import StoreSelectorSheet from '@/components/StoreSelectorSheet/StoreSelectorSheet';
import DeliveryServicesSheet from '@/components/DeliveryServiceSheet/DeliveryServiceSheet';
import { useTranslations } from 'next-intl';
import { GuestAddressStore } from '@/store/GuestAddress';
import User from '@/store/user';
import GuestUserStore from '@/store/guestUser';
import { useIsRtl } from '@/contexts/DirectionContext.jsx';

export default function Aside(props) {
  const [sideSheet, setSideSheet] = useState(false);
  const [isActionValid, setIsActionValid] = useState(true);
  const [addressUnsupportedConfiguration, setAddressUnsuportedConfiguration] = useState();
  const isRtl = useIsRtl();

  const { selectedService } = useContext(DeliveryServicesContext);

  const refOne = useRef(null);

  const onClick = () => {
    if (!User.getValue() && !!GuestUserStore.getValue()) {
      GuestAddressStore.getValue().submitAddress();
    } else {
      setTimeout(() => {
        SideSheetStore.close();
      }, '300');
    }
  };

  useEffect(() => {
    const SideSheetStore$ = SideSheetStore.subscribe(setSideSheet);
    const sub = GuestAddressStore.subscribe(d => {
      if (!User.getValue() && !!GuestUserStore.getValue()) {
        setIsActionValid(d.isValid);
        setAddressUnsuportedConfiguration(d.addressUnsupportedConfiguration);
      }
    });

    document.addEventListener('click', handleClickOutside, true);

    return () => {
      SideSheetStore$.unsubscribe();
      sub.unsubscribe();

      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = e => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      SideSheetStore.close();
    }
  };

  const shouldShowStoresSelection = !selectedService?.deliversToAddress;

  const t = useTranslations('common.asides');

  if (!sideSheet) return null;

  // useDisableBodyScroll();
  return (
    <div ref={refOne}>
      <SideSheet
        header={!shouldShowStoresSelection ? t('service_address.select_address') : t('service_address.select_store')}
        hasClose={true}
        onClose={onClick}
        buttonText={
          addressUnsupportedConfiguration ? addressUnsupportedConfiguration.onSubmitText : t('service_address.save_btn')
        }
        onSubmit={addressUnsupportedConfiguration ? addressUnsupportedConfiguration.onSubmit : onClick}
        onAction={addressUnsupportedConfiguration ? SideSheetStore.close : null}
        actionButtonText={addressUnsupportedConfiguration ? addressUnsupportedConfiguration.actionText : null}
        hasBack={props.hasBack}
        onBack={props.onBack}
        isDisabled={!isActionValid}
        isRtl={isRtl}
      >
        {shouldShowStoresSelection ? (
          <StoreSelectorSheet responsiveLogo={props.responsiveLogo} />
        ) : (
          <DeliveryServicesSheet responsiveLogo={props.responsiveLogo} />
        )}
      </SideSheet>
    </div>
  );
}
